import { RelatedEntities, RelatedEntityKey } from "../types";

export const getRelatedEntitiesKeys = (related: RelatedEntities): RelatedEntityKey[] => {
  return Object.entries(related.counts)
    .filter(k => k[1] > 0)
    .map(k => k[0])
    .map(k => k as RelatedEntityKey);
};
